import { Box, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { classes } from './styles';
import { theme } from '../../../../ThemeContext/ThemeObject';

type Props = {
  title: string;
  checked: boolean;
};

const RadioLabel = ({ children, title, checked }: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        ...classes.radioLabelContainer,
        ...(checked && { borderColor: theme.palette.secondary.main })
      }}
    >
      <Typography sx={classes.radioLabelTitle}>{title}</Typography>
      <Typography sx={classes.radioLabelBody}>{children}</Typography>
    </Box>
  );
};

export default RadioLabel;
